/* this file added by Bearer Web Developer  */
import React from 'react';
import styles from './pickup.module.scss';
import { useAppState } from '../../../../states/app-state';
import { useThemeMode } from '../../../../states/contexts/theme';
import getTime from '../../../../app/getTime';

const Pickup: React.FC = () => {
    const appState = useAppState();
    const activeManageOrder = appState?.ReservedOrders?.activeManageOrder;
    const miliseconds = Number(activeManageOrder?.earliest_pickup_time);
    const pickupDate = new Date(miliseconds).toLocaleDateString();
    const pickupTime = getTime(miliseconds);
    const { theme } = useThemeMode(); // added by Bearer Web Developer
    return (
        <div className={styles.pickup_time} data-theme={theme}> {/* data-theme property added by Bearer Web Developer */}
            <h4>Pick up by:</h4>
            <div className={styles.earliest_time}>
                <span className={styles.time}>{pickupDate}</span>
                <div className={styles.line}></div>
                <span className={styles.time}>{pickupTime}</span>
            </div>
        </div>
    )
}
export default Pickup;